import { useGraphqlQuery } from "@harea/component";
import { THolidaysResponse } from "@harea/component";
import moment from "moment";
import { OffDayListQuery } from "queries/OffDayListQuery";

export const useOffDayListQuery = (
    suspense?: boolean,
    year?: number,
    personnelId?: number
) => {
    return useGraphqlQuery<OffDayListQuery, THolidaysResponse>(
        new OffDayListQuery({
            data: {
                year: year ?? moment().year(),
                ...(personnelId ? { personnelGroup: { personnels: {id : personnelId } } } : {})
            }
        }),
        { suspense }
    );
};
